/** Only the registered login callback can deliver an authorization code. */
export function desktopAuthCallback(input: string): { code: string; error: string | null } | null {
  let url: URL
  try {
    url = new URL(input)
  } catch {
    return null
  }
  if (
    url.protocol !== 'sofa:' ||
    url.hostname !== 'auth' ||
    url.pathname !== '/callback' ||
    url.username ||
    url.password ||
    url.port ||
    url.hash
  )
    return null
  const error = url.searchParams.get('error_description') || url.searchParams.get('error')
  const codes = url.searchParams.getAll('code')
  if (error) return { code: '', error }
  if (codes.length !== 1 || !codes[0] || codes[0].length > 2048) return null
  return { code: codes[0], error: null }
}
